import { useQuery } from '@apollo/client'

import {
  ConnectionRequestStatus,
  NewSubmissionsDocument,
  SubmissionStatusOptions,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  query NewSubmissions($filters: SubmissionsFilter) {
    submissions(filters: $filters) {
      totalCount
    }
  }
`

export const useNewSubmissions = (skip?: boolean) => {
  const { data } = useQuery(NewSubmissionsDocument, {
    client: atlasClient,
    skip,
    fetchPolicy: 'no-cache',
    variables: {
      filters: {
        statuses: [SubmissionStatusOptions.NEW],
        connectionRequestStatuses: [ConnectionRequestStatus.PENDING],
      },
    },
  })

  return data?.submissions?.totalCount ?? 0
}
